import { render, staticRenderFns } from "./GithubSaveModal.vue?vue&type=template&id=9dbe348a&"
import script from "./GithubSaveModal.vue?vue&type=script&lang=js&"
export * from "./GithubSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubSaveModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubSaveModal.vue
// module id = 2367
// module chunks = 1